// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_xWe","cls2":"UserTaggingPingBodyStyles-cls2_hid UserTaggingPingBodyStyles-cls1_xWe"};